const config = {
  apiBaseUrl: 'https://plaindold-api.shop/',
  // apiBaseUrl: 'http://localhost:8000'
};

export default config;
